import { render, staticRenderFns } from "./LottieAnimation.vue?vue&type=template&id=1fa76a68&"
import script from "./LottieAnimation.vue?vue&type=script&lang=js&"
export * from "./LottieAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports